import { FC } from 'react';

import { IconProps } from '../types';

export const RutubeIcon: FC<IconProps> = ({ size, height = 16, width = 18, color = '#06519E' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 18 16"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M4.74 5.972h7.57c.3 0 .449-.03.51-.047a.84.84 0 0 0 .033-.264V4.557a.751.751 0 0 0-.033-.25c-.056-.02-.205-.06-.51-.06H4.74v1.725Zm7.57 1.35H4.066a.675.675 0 0 1-.675-.675V3.572c0-.373.302-.675.675-.675h8.244c.637 0 1.092.123 1.391.377.229.195.502.575.502 1.283v1.104c0 .724-.273 1.108-.502 1.303-.289.245-.713.355-1.373.357h-.018Zm1.571 5.823h2.082L13.52 9.933a.675.675 0 0 1 .433-1.076c.832-.13 1.423-.42 1.758-.864.35-.462.534-1.289.534-2.391v-.985c0-.65-.065-1.185-.192-1.592a2.305 2.305 0 0 0-.558-.92 2.646 2.646 0 0 0-.984-.567c-.447-.125-1.002-.188-1.652-.188H1.35v11.795h2.04V9.543c0-.372.303-.675.676-.675h6.497c.222 0 .43.109.555.29l2.763 3.987Zm3.444 1.35h-3.797a.675.675 0 0 1-.555-.29l-2.763-3.987H4.74v3.602a.675.675 0 0 1-.674.675H.675A.675.675 0 0 1 0 13.82V.675C0 .302.302 0 .675 0H12.87c.775.001 1.454.082 2.02.242a4.008 4.008 0 0 1 1.559.908c.426.439.718.92.89 1.471.17.538.255 1.21.255 1.996v.985c0 1.419-.271 2.497-.806 3.205-.377.498-.905.872-1.578 1.12l2.652 3.484a.675.675 0 0 1-.537 1.084Z"
		/>
	</svg>
);
